
  import { Component, Vue } from 'vue-property-decorator'

  import Bus from '@/helpers/EventBus'
  import { closeBundleModal, openBundleModal } from '@/modals/bundleModal'

  @Component({
    components: {},
  })
  export default class BundleMobileCartButton extends Vue {
    open: boolean = false

    get displayTicketCount(): string {
      // Return the bundle ticket count (1 bundle)
      return '1'
    }

    created() {
      Bus.$on('opened:modal', ({ options }) => {
        if (options.name === 'mobile-bundle-cart') {
          this.open = true
        }
      })

      Bus.$on('closed:modal', ({ instance }) => {
        if (instance.name === 'mobile-bundle-cart') {
          this.open = false
        }
      })
    }

    toggleCart() {
      if (this.open) {
        closeBundleModal()
      } else {
        openBundleModal()
      }
    }
  }
